import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import * as types from '../../redux/futures/tools/types';
import toolsActions from '../../redux/futures/tools/actions';
import _ from 'lodash';
import CustomDatePicker from '../../components/DatePicker/CustomDatePicker';
import Input from '../../components/Input';
import baseHelper from '../../helpers/BaseHelper';
class ZaloReport extends React.Component {
    static propTypes = {
        currentUser: PropTypes.object,
        onCancel: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            start_time: moment().subtract(1, 'month').toDate(),
            end_time: moment().toDate(),
            type: "ZALO_ZNS", // ZALO_CARE
            template_id: "",
            zalo_oa_id: "",
            zaloReport: false
        };
        this.inputsRef = new Set();

    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.tools.action == types.LIST_ZALO_REPORT) {
            if (nextProps.tools.status) {
                window.LadiUI.toastr('success', '', nextProps.tools.message);
                this.setState({ zaloReport: nextProps.tools.result });
            } else {
                window.LadiUI.toastr('error', '', nextProps.tools.message);
            }
        }
    }

    submit = () => {

        // Validate
        let errors = [];
        let { start_time, end_time, type, template_id, zalo_oa_id } = this.state;
        // Normalize to the beginning of the start date and the end of the end date
        start_time = moment(start_time).startOf('day').format('YYYY-MM-DD');
        end_time = moment(end_time).endOf('day').format('YYYY-MM-DD');

        const jsonData = { start_time, end_time, type, template_id, zalo_oa_id }
        this.props.listZaloReport(jsonData);

        this.state.loading = true;
        this.state.classApply = this.state.classLoading;
    }
    handleStartTimeChange = (date) => {
        this.setState({ start_time: date });
    }
    handleEndTimeChange = (date) => {
        this.setState({ end_time: date });
    }
    handleTypeChangeType = (e) => {
        this.setState({ type: e.target.value });
    }
    handleTemplateIdChange = (e) => {
        this.setState({ template_id: e.target.value });
    }
    handleZaloOaIdChange = (e) => {
        this.setState({ zalo_oa_id: e.target.value });
    }
    render() {
        const { start_time, end_time, type, template_id, zalo_oa_id, zaloReport } = this.state;
        const isLoading = this.props.tools.loading && this.props.tools.waitting == types.LIST_ZALO_REPORT;

        return (
            <div id="modal-zalo-report" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-zalo-report" style={{ zIndex: '21' }}>
                <div className="ladiui-modal-content">
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-zalo-report">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-zalo-report" />
                        </button>
                        <h3>Zalo Report</h3>
                    </div>
                    <div className="ladiui-modal-body">
                        <div className=" ladiui form-group">
                            <label>Start Time</label>

                            <CustomDatePicker
                                customClass="ladiui input date"
                                selected={this.state.start_time}
                                onChange={this.handleStartTimeChange}
                            />
                        </div>
                        <div className=" ladiui form-group">
                            <label>End Time</label>
                            <CustomDatePicker
                                customClass="ladiui input date"
                                selected={this.state.end_time}
                                onChange={this.handleEndTimeChange}
                            />
                        </div>
                        <div className=" ladiui form-group">
                            <label>Type Lựa chọn loại report (ZALO_CARE, ZALO_ZNS):</label>
                            <Input
                                ref={(ref) => this.inputsRef.add(ref)}
                                name="type"
                                validationName="Tên gói"
                                placeholder="Type"
                                value={type}
                                onChange={this.handleTypeChangeType}
                                validations={{ isRequired: true }}
                            />
                        </div>
                        <div className=" ladiui form-group">
                            <label>Template ID</label>
                            <Input
                                ref={(ref) => this.inputsRef.add(ref)}
                                name="template_id"
                                validationName="Template ID"
                                placeholder="Template ID"
                                value={template_id}
                                onChange={this.handleTemplateIdChange}
                            />
                        </div>
                        <div className=" ladiui form-group">
                            <label>Zalo OA ID</label>
                            <Input
                                ref={(ref) => this.inputsRef.add(ref)}
                                name="zalo_oa_id"
                                validationName="Zalo OA ID"
                                placeholder="Zalo OA ID"
                                value={zalo_oa_id}
                                onChange={this.handleZaloOaIdChange}
                            // validations={{ isRequired: true }}
                            />
                        </div>
                        {zaloReport &&
                            <React.Fragment>
                                <div className=" ladiui form-group">
                                    <div>Total Money: {baseHelper.numberWithCommas(zaloReport.total_money)}</div>
                                    <div>Total Credits: {baseHelper.numberWithCommas(zaloReport.total_credits)}</div>
                                    <div>Total Messages: {baseHelper.numberWithCommas(zaloReport.total_messages)}</div>
                                    <div>Start Time: {zaloReport.start_time}</div>
                                    <div>End Time: {zaloReport.end_time}</div>
                                </div>

                            </React.Fragment>
                        }
                    </div>
                    <div className="ladiui-modal-footer">
                        <button className="ladiui button secondary close-modal icon" data-dismiss="modal-zalo-report">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-zalo-report" />Đóng
                        </button>
                        <button className="ladiui button primary" onClick={this.submit}>Get Report</button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    tools: { ...state.tool }

});
const mapDispatchToProps = (dispatch) => ({
    listZaloReport: (data) => dispatch(toolsActions.listZaloReport(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ZaloReport); 